import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { produce } from 'immer';
export const USER_PROGRESS_LOCALSTORAGE_KEY = 'academy:userProgress';
export const useUserProgressState = create()(persist(set => ({
  simulateNoProgress: false,
  setSimulateNoProgress: simulateNoProgress => set(produce(state => {
    state.simulateNoProgress = simulateNoProgress;
  }))
}), {
  name: USER_PROGRESS_LOCALSTORAGE_KEY
}));